import { getAttributesFor, setAttributeFor } from "routes/schedule/compare/register-task-comparitor"
import { CompareSchedules } from "event-definitions"

export function processDifferences(differences, otherDifferences, comparisonDifferences) {
    if (!otherDifferences) return differences

    // Render draft-versus-latest entries so task/reference actions have the right direction.
    // The baseline comparisons only identify who changed each field.
    const localChanges = new Set(differences.map(getDifferenceKey))
    const remoteChanges = new Set(otherDifferences.map(getDifferenceKey))
    // A whole task added or removed on one side conflicts with any edit to that task on the other
    const localTasks = new Set(differences.map(getTaskKey).filter(Boolean))
    const remoteTasks = new Set(otherDifferences.map(getTaskKey).filter(Boolean))
    return comparisonDifferences.map(markDifference)

    function markDifference(difference) {
        const attributes = getAttributesFor(difference)
        if (!attributes) return difference
        const key = getDifferenceKey(difference)
        const wholeTask = isWholeTask(difference)
        const taskKey = getTaskKey(difference)
        const local = wholeTask ? localTasks.has(taskKey) : localChanges.has(key)
        const remote = wholeTask ? remoteTasks.has(taskKey) : remoteChanges.has(key)
        return setAttributeFor(
            <difference.type
                {...difference.props}
                isLocal={local && !remote}
                isRemote={remote && !local}
                isConflict={local && remote}
            />,
            attributes
        )
    }
}

function getDifferenceKey(difference) {
    const attributes = getAttributesFor(difference)
    const guidance = difference.props.children?.props?.guidance
    const taskKey = getTaskKey(difference)
    if (taskKey) return `${taskKey}:${attributes?.name ?? "task"}`
    if (guidance != null) return `guidance:${guidance}`
    return attributes?.name
}

function getTaskKey(difference) {
    const { task } = difference.props
    return task ? `task:${task.taskId ?? task.id}` : undefined
}

function isWholeTask(difference) {
    return !!difference.props.task && !getAttributesFor(difference)?.name
}

export function getDifferences(compare, to, target, comparedWith = to) {
    const { differences } = CompareSchedules.call({ differences: [], compare, to, target, comparedWith })
    return differences.filter(Boolean)
}
